import React from 'react';
import {Link} from 'react-router-dom';
import Pagination from "react-js-pagination";
import DownloadRawhands from './DownloadRawhands.js'

class PokerwatchTable extends React.Component {
    constructor(props){
        super(props)
        this.state={
            max: 10,
            offset: 0,
            sortBy: 'asc',
            activePage: 1,
            currColumn: 'profit',
            sortColumn:'Profit/Loss',
            totalCount: props.totalCount,
            searchPlayerSummary:props.searchPlayerSummary,

        }
    }

    componentWillReceiveProps(nextProps) {
        this.setState({
            searchPlayerSummary:nextProps.searchPlayerSummary,
            totalCount: nextProps.totalCount
        })
    }
  
    sorting = (column) =>{
        if(column == this.state.currColumn) {
          if(this.state.sortBy == 'asc') this.state.sortBy = 'desc'
          else this.state.sortBy = 'asc'
        } else 
          this.state.sortBy = 'asc'
        this.state.currColumn = column
        this.state.activePage=1
        this.props.getplayerSummary(this.state.sortBy,this.state.currColumn,10,0)
    }

    handlePageChange = (pageNumber) => {
        this.state.activePage=pageNumber
        this.state.offset = (pageNumber - 1) * this.state.max
        this.props.getplayerSummary(this.state.sortBy,this.state.currColumn,this.state.max,this.state.offset)  
    }

    filteredList = (event) => {
        if(event.target.value.trim() == '')
            this.setState({searchPlayerSummary : this.props.searchPlayerSummary})
        else{
            var updatedList = this.props.searchPlayerSummary;
            updatedList = updatedList.filter(function(item) {
                return item.playerAlias.toLowerCase().search(event.target.value.trim().toLowerCase()) !== -1;
            });
            this.setState({searchPlayerSummary: updatedList});
        }
    }

    sortingForMob = (event) =>{
        this.state.sortColumn = event.target.value
        if(this.state.sortColumn=='playerAlias')  this.setState({sortColumn:'Trader Name'})
        else if(this.state.sortColumn=='games')  this.setState({sortColumn:'Game'})
        else if(this.state.sortColumn=='player_rake')  this.setState({sortColumn:'Rake'})
        else  this.setState({sortColumn:'Profit/Loss'})
        var value = event.target.value;
        if(value!=null){
            if(value==0){
                this.state.msg="please select proper sort"
                this.handleOpen();
            }else {
                if(value=="playerAlias" || value=="player_rake" || value=="games" || value=="profit"){
                this.setState({value:'0'});
                this.sorting(value)
                }
            }
        }
    }

    render(){
        return (
            <div>
                <br/>
                {/* <div className="row">
                    <div className="col-sm-12">
                        <TextField hintText="Search By Name" fullWidth={true}  ref="searchText" onChange={this.filteredList}/>
                    </div>
                </div> */}
                {/* <br/><br/> */}
                <center>
                    <div className="form-group">
                        <select className="resp-table-select form-control" onChange={this.sortingForMob} value={this.state.value} >
                            <option value="0">Sort By {this.state.sortColumn}</option>
                            <option value="profit">Profit/Loss</option>
                            <option value="playerAlias">Trader Name</option>
                            <option value="games" >Games</option>
                            <option value="player_rake">Rake</option>
                        </select>
                    </div>
                </center>
               
                    <div>
                        <table className="resp-table resp-table-background">
                            <thead className="resp-table-head">
                                <tr className="resp-table-tr">
                                    <th  onTouchTap={() =>  this.sorting('playerAlias')} className="resp-table-th">Trader Name&nbsp;
                                        <i className="fa fa-sort " ></i>
                                    </th>
                                    <th  onTouchTap={() => this.sorting( 'games')} className="resp-table-th">Games&nbsp;
                                        <i className="fa fa-sort "></i>
                                    </th>
                                    <th  onTouchTap={() => this.sorting('player_rake')} className="resp-table-th">Rake&nbsp;
                                        <i className="fa fa-sort "></i>
                                    </th>
                                    <th  onTouchTap={() => this.sorting('profit')} className="resp-table-th">Profit/Loss&nbsp;
                                        <i className="fa fa-sort "></i>
                                    </th>
                                    {/* <th  className="resp-table-th"></th> */}
                                </tr>
                            </thead>
                            <tbody data-e2e="tableData" className="resp-table-body">
                                {this.state.searchPlayerSummary.map((item, key) => {
                                return (
                                    <tr key={key} className="resp-table-tr">
                                        <td className="pokerWatchtd resp-table-td"><span data-e2e="clickPlayer"><Link onClick={this.props.onRedirect} style={{color: '#DE460F', fontWeight: 'bold'}}  to={'/playerDetails/'+this.props.searchTime.reqFromDate+'/'+this.props.searchTime.reqToDate+'/'+this.props.searchTime.reqFromTime+'/'+this.props.searchTime.reqToTime+'/'+this.props.searchTime.shift+'/'+item.playerAlias+'/'+item.accountName}>{item.playerAlias}</Link></span></td>
                                        <td className="pokerWatchtd resp-table-td">{item.games}</td>
                                        <td className="pokerWatchtd resp-table-td">{item.player_rake}</td>
                                        <td className="pokerWatchtd resp-table-td">{item.profit}</td>
                                        {/* <td className="pokerWatchtd resp-table-td" style={{padding: '0px'}}>
                                          <DownloadRawhands fromDate={this.props.searchTime.reqFromDate} toDate={this.props.searchTime.reqToDate} fromTime={this.props.searchTime.reqFromTime} toTime={this.props.searchTime.reqToTime} shift={this.props.searchTime.shift} accountName={item.accountName} totalGame={item.games} showType="icon"/>
                                        </td> */}
                                    </tr>
                                )
                                })}
                            </tbody>
                        </table>
                       {this.state.totalCount >10 &&
                         <div>
                         <div style={{textAlign: "center"}}>
                         <span data-e2e='pagination'>
                             <Pagination prevPageText='Prev'
                                 nextPageText='Next'
                                 firstPageText='First'
                                 lastPageText='Last'
                                 activePage={this.state.activePage}
                                 itemsCountPerPage={this.state.max}
                                 totalItemsCount={this.state.totalCount}
                                 pageRangeDisplayed={5}
                                 onChange={this.handlePageChange}/>
                          </span>
                         </div>
                     </div>}
                    </div>


            </div>
        );
    }
  }


  export default PokerwatchTable;



/** WEBPACK FOOTER **
 ** ./src/components/PokerWatchComp/PokerwatchTable.js
 **/